import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.99997 5C5.99997 3.34315 7.34312 2 8.99997 2C10.6568 2 12 3.34315 12 5V9H5.99997V5ZM3.99997 9V5C3.99997 2.23858 6.23855 0 8.99997 0C11.7614 0 14 2.23858 14 5V9H14.9999C16.6567 9 17.9999 10.3431 17.9999 12V17C17.9999 18.6569 16.6567 20 14.9999 20H3C1.34313 20 -2.43187e-05 18.6568 0 17L7.31349e-05 12C9.7394e-05 10.3431 1.34324 9 3.00007 9H3.99997ZM2.00007 12C2.00008 11.4477 2.44779 11 3.00007 11H14.9999C15.5522 11 15.9999 11.4477 15.9999 12V17C15.9999 17.5523 15.5522 18 14.9999 18H3C2.44771 18 1.99999 17.5523 2 17L2.00007 12Z",
		fill: "currentColor"
	})
});
export default SvgLock;
